"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _sharedIntlProviderHOC = _interopRequireDefault(require("../hocs/sharedIntlProviderHOC"));
var _localeSelector = require("../internationalization/locale-selector");
var _reactCookie = _interopRequireDefault(require("react-cookie"));
var _get = _interopRequireDefault(require("lodash/get"));
var _LocaleAbbreviation = _interopRequireDefault(require("./LocaleAbbreviation"));
var _PrivacyOptionsIcon = _interopRequireDefault(require("./PrivacyOptionsIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Footer = (0, _reactIntl.injectIntl)(function (_ref) {
  var intl = _ref.intl,
    locale = _ref.locale,
    envLocaleData = _ref.envLocaleData;
  //this locale and envLocaleData is from the server-side rendering
  var preferredLocale = _reactCookie.default.load('preferred_locale'); //use cookie for client-side
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    displayCountries = _useState2[0],
    setDisplayCountries = _useState2[1];
  var currentLocale = locale || preferredLocale || _reactCookie.default.load('initial_locale');
  var localeData = envLocaleData || _sharedIntlProviderHOC.default.getEnvLocaleData() || {}; // use sharedintlproviderhoc for client side
  var currentLocaleData = localeData[currentLocale];
  var altText = (0, _reactIntl.defineMessages)({
    footer: {
      id: 'shared_component.footer.footer_logo',
      defaultMessage: 'Peerspace footer logo'
    },
    download: {
      id: 'shared_component.footer.download_logo',
      defaultMessage: 'download logo'
    }
  });
  var urlPrefix = _sharedIntlProviderHOC.default.getUrlPrefix();
  var urlPrefixLink = urlPrefix ? "/".concat(urlPrefix) : '';
  var zenDeskLocale = _sharedIntlProviderHOC.default.getZendeskLocale();
  var lang = intl.locale.split('-')[0];
  (0, _react.useEffect)(function () {
    setDisplayCountries(!preferredLocale);
  }, [preferredLocale]);
  return /*#__PURE__*/_react.default.createElement("footer", null, /*#__PURE__*/_react.default.createElement("div", {
    role: "navigation",
    className: "container-fluid"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row footer-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-md-3 col-lg-3 footer-peerspace-connect"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "footer-logo",
    src: "/web-templates/assets/images/ps_logo_stack_white.svg?v=rb",
    alt: intl.formatMessage(altText.footer)
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "/download"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://assets.peerspace.com/ios-footer-download-".concat(lang, ".svg?v=rb"),
    alt: intl.formatMessage(altText.download)
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row hidden-xs margin-lg-top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "copyright"
  }, "\xA9 Peerspace\xA0-\xA0", /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlPrefixLink, "/legal/terms")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.terms",
    defaultMessage: "Terms"
  })), "\xA0-\xA0", /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlPrefixLink, "/legal/privacy")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.privacy",
    defaultMessage: "Privacy"
  })))))), /*#__PURE__*/_react.default.createElement("br", {
    className: "visible-xs"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-md-8 col-lg-8"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row web-links"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-4 no-gutter"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.company",
    defaultMessage: "Company"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_about",
    href: "https://book.peerspace.com/about"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.about",
    defaultMessage: "About"
  }))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_press",
    href: "//try.peerspace.com/press/"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.press",
    defaultMessage: "Press"
  }))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_careers",
    href: "https://jobs.lever.co/peerspace"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.careers",
    defaultMessage: "Careers"
  }))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_blog",
    href: "/resources"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.blog",
    defaultMessage: "Blog"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.social",
    defaultMessage: "Social"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_facebook",
    href: "https://www.facebook.com/peerspace/"
  }, "Facebook")), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_instagram",
    href: "https://www.instagram.com/peerspace/"
  }, "Instagram")), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_twitter",
    href: "https://x.com/Peerspace"
  }, "Twitter")), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_linkedin",
    href: "https://www.linkedin.com/company/peerspace"
  }, "LinkedIn")), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_pinterest",
    href: "http://www.pinterest.com/peerspace/"
  }, "Pinterest")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 col-sm-4 no-gutter"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.explore",
    defaultMessage: "Explore"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlPrefixLink, "/plan/activities")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.activities",
    defaultMessage: "Activities"
  }))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlPrefixLink, "/venues/locations")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.locations",
    defaultMessage: "Locations"
  }))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_blog",
    href: "/resources"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.resources",
    defaultMessage: "Resources"
  }))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://madein.peerspace.com/ambassadors"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.ambassadors",
    defaultMessage: "Ambassador Program"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.host",
    defaultMessage: "Host"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_host",
    href: "".concat(urlPrefixLink, "/host")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.list_your_space",
    defaultMessage: "List your space"
  }))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_forum",
    href: "https://community.peerspace.com"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.community",
    defaultMessage: "Community"
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-6 col-sm-4 no-gutter"
  }, displayCountries && /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.countries",
    defaultMessage: "Countries"
  })), Object.keys(localeData || {}).map(function (locale) {
    return /*#__PURE__*/_react.default.createElement("p", {
      key: locale
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "/".concat(localeData[locale].url_prefix)
    }, localeData[locale].country));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "title"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.support",
    defaultMessage: "Support"
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_support",
    href: "https://support.peerspace.com/hc/".concat(zenDeskLocale)
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.help_center",
    defaultMessage: "Help Center"
  }))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_covid",
    href: "https://book.peerspace.com/covid-19/overview"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.covid_measures",
    defaultMessage: "COVID-19 Measures"
  }))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_trust",
    href: "https://book.peerspace.com/trust-and-safety"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.trust_safety",
    defaultMessage: "Trust and Safety"
  }))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    className: "text-gray-500",
    id: "footer_link_disclosure",
    href: "".concat(urlPrefix ? "/".concat(urlPrefix) : '', "/legal/privacy#california-privacy")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.california_privacy_link",
    defaultMessage: "California Privacy"
  }))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    id: "footer_link_disclosure",
    href: "mailto:vulnerability@peerspace.com"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.report_vulnerability",
    defaultMessage: "Report Vulnerability"
  }))))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row visible-xs margin-xl-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "copyright"
  }, "\xA9 Peerspace\xA0-\xA0", /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlPrefixLink, "/legal/terms")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.terms",
    defaultMessage: "Terms"
  })), "\xA0-\xA0", /*#__PURE__*/_react.default.createElement("a", {
    href: "".concat(urlPrefixLink, "/legal/privacy")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.privacy",
    defaultMessage: "Privacy"
  })))))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-gray-900 padding-xl-left padding-xl-right flex middle"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "margin-xl-top margin-xl-bottom margin-xl-right margin-xl-left flex middle"
  }, /*#__PURE__*/_react.default.createElement(_localeSelector.LocaleSelector, {
    source: "footer",
    activeLocales: envLocaleData
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "border-0 text-gray-500 underline"
  }, (0, _get.default)(currentLocaleData, 'language', 'en-US'), " (", (0, _LocaleAbbreviation.default)((0, _get.default)(currentLocaleData, 'locale', 'en-US')), ")")), /*#__PURE__*/_react.default.createElement("div", {
    className: "margin-sm-right margin-sm-left text-gray-500 flex"
  }, "\u2022"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn-link text-left text-gray-500 no-padding",
    id: "footer_link_cookies",
    onClick: function onClick() {
      if (typeof window !== 'undefined') {
        window.consentManager.openConsentManager();
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_component.footer.your_privacy_choices",
    defaultMessage: "Your privacy choices"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "margin-sm-left flex"
  }, /*#__PURE__*/_react.default.createElement(_PrivacyOptionsIcon.default, null)))));
});
var IntlFooter = /*#__PURE__*/function (_React$Component) {
  _inherits(IntlFooter, _React$Component);
  function IntlFooter(props) {
    _classCallCheck(this, IntlFooter);
    return _callSuper(this, IntlFooter, [props]);
  }
  _createClass(IntlFooter, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_sharedIntlProviderHOC.default, {
        locale: this.props.locale,
        envLocaleData: this.props.envLocaleData
      }, /*#__PURE__*/_react.default.createElement(Footer, this.props));
    }
  }]);
  return IntlFooter;
}(_react.default.Component);
exports.Footer = IntlFooter;